export const playJoinNotification = () =>
  new Promise((resolve) => {
    var audio = new Audio('/assets/sounds/ding.mp3');
    const promise = audio.play();
    if (promise !== undefined) {
      promise
        .then(() => {
          resolve();
        })
        .catch(() => {
          resolve();
        });
    }
  });

export const minTwoDigits = (n) => {
  return (n < 10 ? '0' : '') + n;
};

export const extractUserInfo = (user) => ({
  id: user?.id,
  user: {
    givenName: user?.FirstName,
    familyName: user?.LastName,
    image: user?.thumbnail,
  },
});

const checkLanguage = () => {
  if (location.search) {
    const params = new URLSearchParams(location.search);
    return params.get('lang') || 'it';
  }
  return 'it';
};

export { checkLanguage };
